import React, { useCallback } from "react";
import { useFormikContext } from "formik";
import { Grid } from "@material-ui/core";
import { InputDateRange } from "components/DateRangePicker/dateRangePicker";
import { withNamespace } from "components/Form/FormikControls";

export interface FinancialStatementFormValues {
  startDate: Date | null;
  endDate: Date | null;
}

type FinancialStatementFormProps = {
  namespace?: string;
};

export function FinancialStatementForm(
  props: FinancialStatementFormProps,
): React.JSX.Element {
  const { namespace: ns = "" } = props;

  const { values: formValues, setValues } =
    useFormikContext<FinancialStatementFormValues>();

  const updateDates = useCallback(
    (startDate, endDate) => {
      const newValue: FinancialStatementFormValues = {
        ...formValues,
        // Naively apply the new dates to the root of the form values
        startDate,
        endDate,
      };
      setValues(newValue, true);
    },
    [formValues, setValues],
  );

  return (
    <>
      <Grid item xs={12}>
        <p>
          Generate Financial Statements containing start balance, closing
          balance, charges and payments within the given date range.
        </p>
      </Grid>

      <InputDateRange
        endDateFieldName={withNamespace(ns, "endDate")}
        endDateLabel="End date"
        includeTime={false}
        showRangeOptions
        showYearOptions
        startDateFieldName={withNamespace(ns, "startDate")}
        startDateLabel="Start date"
        updateDates={updateDates}
      />
    </>
  );
}
